import { useTranslation } from 'react-i18next';
import type { Supplier } from '@interfaces/ILogistics';
import { telHref } from '@d-orca/shared/client/utils';
import { CheckIcon, CopyIcon } from '@utils/icons';
import { copyToClipboard } from '@utils/clipboard';
import { useTransientFlag } from '@hooks/useTransientFlag';
import styles from './DeliveryDetailDrawer.module.css';

export interface ISupplierDetailProps {
  supplier: Supplier;
}

/**
 * The drawer's Supplier value: the company name, then — each only when the
 * supplier has it — the contact person and a dialable phone with a Copy
 * button. The separator is drawn between the parts that exist, never around
 * a missing one.
 */
export function SupplierDetail({ supplier }: ISupplierDetailProps) {
  const { t } = useTranslation();
  const [copied, flashCopied] = useTransientFlag();
  const { contactName, phone } = supplier;

  return (
    <>
      <strong className={styles.supplierName}>{supplier.name}</strong>
      {contactName || phone ? (
        <span className={styles.supplierContact}>
          {contactName}
          {contactName && phone ? ' · ' : null}
          {phone ? (
            <>
              <a href={telHref(phone)}>{phone}</a>
              <button
                type="button"
                className={styles.copyPhone}
                aria-label={copied ? t('logistics.detail.phoneCopied') : t('logistics.detail.copyPhone')}
                onClick={() => void copyToClipboard(phone).then((ok) => ok && flashCopied(true))}
              >
                {copied ? <CheckIcon size={12} /> : <CopyIcon size={12} />}
              </button>
            </>
          ) : null}
        </span>
      ) : null}
    </>
  );
}
